import { render } from "./closeLoopMointor.vue?vue&type=template&id=b772e5fa&scoped=true"
import script from "./closeLoopMointor.vue?vue&type=script&lang=js"
export * from "./closeLoopMointor.vue?vue&type=script&lang=js"

import "./closeLoopMointor.vue?vue&type=style&index=0&id=b772e5fa&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b772e5fa"]])

export default __exports__